import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

const Listdata = ({ ...props }) => {
    const history = useHistory();
    return (
        <>
            <div
                className="section-title with-desc clearfix"
            >
                <div
                    className="title-header"
                >
                    <Link to={`/kategori/detail/${props.DatasetCategorySlug}`}>
                        <h5> <i className="fa fa-angle-right" /> {props.DatasetCategory}</h5>
                    </Link>
                    <Link to={`/data/detail/${props.DataHeaderSlug}`}>
                        <h4 className="title">{props.DataHeaderName}</h4>
                    </Link>
                </div>
                <div
                    className="title-desc"
                    style={{ marginTop: '-20px', cursor: 'pointer' }}
                >
                    <p className="text-justify">{props.DatasetDescription}</p>
                </div>
            </div>
            {
                props.Tags ?
                    <>
                        <label className="mr-2">Tags: </label>
                        {

                            props.Tags.map((v, i) => {
                                return (
                                    <Link key={i} to={`/tag/detail/${v.Slug}`}>
                                        <span className="badge ttm-bgcolor-skincolor mr-1">{v.Name}</span>
                                    </Link>
                                )
                            })
                        }
                    </>

                    : null
            }

            <hr />
        </>
    )
}

export default Listdata
